/*
 * 计算菜单、路由表
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-09-05 17:17:23
 * @Last Modified by: kq.zheng
 * @Last Modified time: 2020-04-29 15:38:03
 */
import { exportModules } from 'functions';

/**
 * 计算module是否可以展示在菜单中
 * 若module中存在shopUserRole数组，则只有该数组中存在的role可以展示;否则是无限制的
 * 若module中存在storeTypes数组，则只有该数组中存在的storeType可以展示；否则是无限制的
 *
 * @param {object} module 菜单配置中的一个节点
 * @param {number} userRole 此用户在某个店铺中的角色;1-管理店铺 2-服务店铺 3-配送店铺 4-工作店铺
 * @param {string} storeType 店铺类型 1普通店铺 2食堂店铺
 */
function checkAuth (module, userRole, storeType, status, privilegeIds) {
	const { shopUserRole, storeTypes, merchantStatus = [], privilegeId } = module;
	// 是否需要满足店铺用户角色条件
	const shopUserRoleRequire = shopUserRole && !shopUserRole.some(role => userRole === role);
	// 是否需要满足店铺类型条件
	const storeTypeRequire = storeTypes && !storeTypes.some(type => storeType === type);
	// 是否需要展示营销模块，未绑定商户不展示
	const showMerchant = merchantStatus && merchantStatus.includes(status);
	// 是否有该模块的权限
	const privilegeRequire = privilegeId && !privilegeIds.includes(privilegeId);
	// 不需要上述条件则有权访问
	return !storeTypeRequire && !shopUserRoleRequire && !showMerchant && !privilegeRequire;
}

/**
 * 计算可以展示在菜单栏中的菜单节点树, 根据权限配置过滤掉不符合条件的节点
 *
 * @param {array} menus 菜单配置数组
 * @param {number} shopUserRole 此用户在某个店铺中的角色;1-管理店铺 2-服务店铺 3-配送店铺 4-工作店铺
 * @param {string} storeType 店铺类型编号
 */
function computeMenus (menus, shopUserRole = '', storeType = '', status = '', privilegeIds = []) {
	const clonedMenus = JSON.parse(JSON.stringify(menus)); // deep clone
	function parse (menus = []) {
		return menus.filter((item) => {
			const hasAuth = checkAuth(item, shopUserRole, storeType, status, privilegeIds);
			if (hasAuth) {
				item.dtos = parse(item.dtos);
				return item.dtos;
			}
			return false;
		});
	}

	return parse(clonedMenus);
}

/**
 * 从菜单路由配置表中转换为真实可挂载的路由
 *
 * @param {array} modules 菜单路由配置数组
 */
function computeRoutes (modules) {
	const routes = [];

	function parse (modules) {
		return modules.map(item => {
			const { dataType, dtos, name, isModule } = item;

			// 这里默认为有dtos的都不是module
			if (!dtos || !dtos.length) {
				if (isModule) {
					return routes.push({
						key: `${dataType}`,
						component: exportModules[dataType],
						name
					});
				}
			} else {
				return parse(dtos);
			}
		});
	}

	// 开始递归
	parse(modules);
	return routes;
}

export default {
	computeMenus,
	computeRoutes,
};
